export const ERROR_DETAILS_START_MARKER = "--- error details ---";
export const ERROR_DETAILS_END_MARKER = "--- end error details ---";

/**
 * Parses a message for `--- error details ---` / `--- end error details ---` delimiters.
 *
 * Returns null if no error details block is found, otherwise returns:
 * - `before`: text before the block
 * - `details`: content inside the block
 * - `after`: text after the block
 */
export function parseErrorDetailsBlock(content: string): { before: string; details: string; after: string } | null {
  const startIdx = content.indexOf(ERROR_DETAILS_START_MARKER);
  if (startIdx === -1) return null;

  const endIdx = content.indexOf(ERROR_DETAILS_END_MARKER, startIdx + ERROR_DETAILS_START_MARKER.length);
  if (endIdx === -1) return null;

  const before = content.slice(0, startIdx).trim();
  const details = content.slice(startIdx + ERROR_DETAILS_START_MARKER.length, endIdx).trim();
  const after = content.slice(endIdx + ERROR_DETAILS_END_MARKER.length).trim();

  return { before, details, after };
}
